import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import InstaIframe from "../../../InstaIframe";

const Insta = () => {
  return (
    <>
      <div className="rcs_news_content1 w-100 mt-5 mb-3">
        <h2 className="text-center">Get a Tour of our Social Media</h2>
      </div>
      <InstaIframe />
    </>
  );
};

export default Insta;
